// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBanner_container__WxQ2r","content":"ErrorBanner_content__22usi","header":"ErrorBanner_header__hJsNt","handle":"ErrorBanner_handle__PeZ5W"};